var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7978 20.8057L26.6035 15L20.7978 9.19421L19.9139 10.0781L24.2108 14.375L9.37585 14.375V15.625L24.2107 15.625L19.9139 19.9218L20.7978 20.8057Z",
    fill: "#8586A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37585 5.625L10.6259 5.625V4.375H3.12585V25.625H10.6259V24.375H4.37585V5.625Z",
    fill: "#8586A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7c9ac5cf525cae81e7c77d5546fbf5dd.svg";
export { ForwardRef as ReactComponent };